import { render, staticRenderFns } from "./newsPage.vue?vue&type=template&id=9d088eae&scoped=true&"
import script from "./newsPage.vue?vue&type=script&lang=js&"
export * from "./newsPage.vue?vue&type=script&lang=js&"
import style0 from "./newsPage.vue?vue&type=style&index=0&id=9d088eae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d088eae",
  null
  
)

export default component.exports